<template>
  <el-form
      ref="form"
      :model="form">
    <el-form-item
        v-if="bidInput"
        label="默认竞价"
        prop="bid"
        :label-width="bidLabelWidth">
      <gj-input
          v-model="form.bid"
          width="200px">
        <template #prepend>{{adStore.SD.currencySymbol}}</template>
      </gj-input>
    </el-form-item>
    <el-row
        type="flex"
        class="gj-picker">
      <div class="gj-picker__editor" :style="{width}">
        <el-tabs :value="'first'">
          <el-tab-pane name="first">
            <template #label>
              分类
              <gj-help>各类商品是按相似性划分在一起的商品，如女士跑鞋。</gj-help>
            </template>
            <div class="gj-picker__editor--body" style="margin-top: 1px;">
              <gj-table
                  :index="false"
                  :show-pagination="false"
                  :show-overflow="false"
                  :adapt-height="false"
                  :loading="suggestCategoriesLoading"
                  :height="403"
                  :data="recommendCategoryData"
                  :columns="columns0"
                  class="suggest-table">
                <template v-slot:header:op>
                  <gj-button
                      type="text"
                      @click="addAllCategory()"
                  >定位全部</gj-button>
                </template>
                <template v-slot:recommendCategory="{ row }">
                  <div style="line-height: 18px;">
                    <div>{{row.path | defaultShow}}</div>
                    <div><span style="font-weight: bold;">分类：</span>{{row.name | defaultShow}}</div>
                  </div>
                </template>
                <template v-slot:op="{ index, row }">
                  <gj-button
                      size="mini"
                      type="ghost"
                      :disabled="row.btnDisabled"
                      style="padding: 5px 15px;"
                      @click="addCategory(index, row)"
                  >定位</gj-button>
                  <!--:disabled="row.btnDisabled"-->
                  <gj-button
                      type="text"
                      @click="refineCategory(index, row)"
                  >细化</gj-button>
                </template>
              </gj-table>
            </div>
          </el-tab-pane>
          <el-tab-pane name="second">
            <template #label>
              商品
              <gj-help>定位到与您广告中宣传的商品类似的各个商品。</gj-help>
            </template>
            <el-tabs :value="'first'">
              <el-tab-pane
                  name="first">
                <template #label>
                  建议ASIN
                  <gj-help>根据您广告中宣传的商品建议的商品。</gj-help>
                </template>
                <gj-table
                    :index="false"
                    :show-pagination="false"
                    :show-overflow="false"
                    :adapt-height="false"
                    :loading="suggestProductLoading"
                    :height="358"
                    :data="recommendAsinData"
                    :columns="recommendAsinColumns">
                  <template v-slot:header:op>
                    <gj-button
                        type="text"
                        @click="addAllRecommendAsin()"
                    >定位全部</gj-button>
                  </template>
                  <template v-slot:op="{ index, row }">
                    <gj-button
                        type="text"
                        :disabled="row.btnDisabled"
                        @click="addRecommendAsin(index, row)"
                    >定位</gj-button>
                  </template>
                </gj-table>
              </el-tab-pane>
              <el-tab-pane
                  label="输入ASIN"
                  name="second">
                <div style="padding: 13px 12px 0;">
                  <div style="margin-bottom: 10px;">
                    <gj-textarea
                        v-model="inputText"
                        :styles="{'border-color': this.errorKeyword ? '#F56C6C' : '', ...textareaStyles }"
                        placeholder="请选择关键词，一行一个，回车换行">
                    </gj-textarea>
                  </div>
                  <el-row
                      type="flex"
                      align="middle"
                      justify="space-between"
                      class="gj-picker__editor--footer">
                    <span :class="{red: errorKeyword}">关键词不得包含特殊字符，如@、#、*和$等</span>
                    <gj-button
                        type="primary"
                        @click="addByInput"
                        :disabled="!isMeaningful(inputText)"
                        :loading="loadingInput"
                    >添加</gj-button>
                  </el-row>
                  <el-row style="margin-top: 10px;">
                    <gj-alert
                      v-if="alert.error && alert.error.length !== 0"
                      ref="gjAlert"
                      type="error"
                      show-icon
                      closable
                      @close="closeError">
                      <template #title>
                        <div>{{ `成功${alert.success.length || 0}个，失败${alert.error.length || 0}个` }}</div>
                        <div class="alert-error">{{ `失败原因：ASIN格式不正确或ASIN重复添加，失败的ASIN：${alert.error.join("，")}`}}</div>
                      </template>
                    </gj-alert>
                    <gj-alert
                      v-else
                      ref="gjAlert"
                      type="success"
                      show-icon
                      closable
                      @close="closeError">
                      <template #title>
                        <div class="alert-content">
                          {{ `${alert.success.length || 0}个ASIN全部添加成功` }}
                        </div>
                      </template>
                    </gj-alert>
                  </el-row>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="gj-picker__table" :style="{width}">
        <div class="gj-picker__table--title">
          已添加 {{form.items.length}} 个{{title}}<span class="gj-picker__table--tip">（最多可添加1000个，会过滤重复的{{title}}）</span>
        </div>
        <gj-table
            :index="false"
            :show-pagination="false"
            :show-overflow="false"
            :adapt-height="false"
            :height="403"
            :data="form.items"
            :columns="columns">
          <template v-slot:header:op>
            <gj-button
                type="text"
                @click="deleteAllItem()"
            >全部移除</gj-button>
          </template>
          <template v-slot:category="{ row }">
            <div v-if="row.type === 'path' || row.type === 'refine'" style="line-height: 18px;">
              <div>{{row.path | defaultShow}}</div>
              <div v-gutter="8">
                <strong>分类：</strong>{{row.name | defaultShow}}
                <strong v-if="row.brandId">品牌：</strong>{{row.brandName}}
              </div>
              <div v-gutter="8">
                <span v-if="isMeaningful(row.lowPrice) && isMeaningful(row.maxPrice) "><strong>商品价格：</strong>{{row.lowPrice | defaultShow}} - {{row.maxPrice | defaultShow}} </span>
                <span v-if="isMeaningful(row.lowPrice) && !isMeaningful(row.maxPrice) "><strong>商品价格：</strong>不低于{{row.lowPrice | defaultShow}} </span>
                <span v-if="!isMeaningful(row.lowPrice) && isMeaningful(row.maxPrice) "><strong>商品价格：</strong>不低于{{row.maxPrice | defaultShow}} </span>
                <span v-if="isMeaningful(row.marks)"><strong>评分：</strong>{{starTo(row.marks)}} 星</span>
                <span v-if="isMeaningful(row.prime) && row.prime !== 'NO'"><strong>配送：</strong>{{primeTo(row.prime)}} </span>
              </div>
            </div>
            <template v-if="row.type === 'asin'">
              <div><strong>商品：</strong>{{row.asin | defaultShow}}</div>
            </template>
          </template>
          <template v-slot:bid="{ index }">
            <el-form-item
                :prop="`items.${index}.bid`"
                :rules="[
                  { required: true, message: '请输入竞价', trigger: ['blur', 'change'] },
                  $gjReRule(RE.num(2), '最多两位小数的正数'),
                  $gjMinRule(0.02, '应大于等于0.02')
                ]"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[index].bid"
                  size="mini"
                  width="115px">
                <template #prepend>{{adStore.SD.currencySymbol}}</template>
              </gj-input>
            </el-form-item>
          </template>
          <template v-slot:op="{ index, row }">
            <gj-button
                type="text"
                @click="deleteItem(index, row)"
            >移除</gj-button>
          </template>
        </gj-table>
      </div>
    </el-row>
    <div class="gj-picker-solid"></div>
  </el-form>
</template>

<script>
  import {formMixin, formRuleMixin, isMeaningfulMixin} from "../../../../../../../../minxins";
  import {isMeaningful, unique} from "../../../../../../../../utils/common";
  import AppProductTargetRefineModal from "./modal/product-target-refine-modal";
  import {adStore} from "../../../../../common/store";
  import {
    getAdProductTargetBrand,
    getAdProductTargetCategories,
    getSdAdProductTargetProduct
  } from "../../../../../../../../api/ad";

  export default {
    name: "app-product-target-picker",
    mixins: [isMeaningfulMixin, formMixin, formRuleMixin],
    props: {
      marketId: {
        required: true
      },
      title: {
        required: true,
      },
      bidInput: {
        type: Boolean,
        default: false,
      },
      bidLabelWidth: {
        type: String,
        default: '150px'
      },
      width: {
        type: String,
        default: '500px',
      },
      adProduct$: {
        required: true
      }
    },
    created() {
    },
    mounted () {
      this.$refs.gjAlert.$refs.alert.visible = false;
    },
    data() {
      return {
        recommendCategoryData: [],
        recommendAsinData: [],
        keyword: null,
        inputText: null,
        loadingInput: false,
        columns0: [
          {id: 'recommendCategory', header: '建议分类',field: 'slot:recommendCategory', minWidth: '180px'},
          {id: 'op', header: 'slot:op',field: 'slot:op', width: '120'},
        ],
        columns: [
          {id: 'category', header: '分类和商品',field: 'slot:category', minWidth: '180px'},
          {id: 'bid', header: '竞价', field: 'slot:bid', width: '130px'},
          {id: 'op', header: 'slot:op',field: 'slot:op', width: '80'},
        ],
        recommendAsinColumns: [
          {id: 'smallImageUrl', header: '图片',field: 'picture:smallImageUrl', width: '60px'},
          {id: 'asin', header: '建议ASIN', field: 'asin', minWidth: '130px'},
          {id: 'op', header: 'slot:op',field: 'slot:op', width: '80'},
        ],
        errorKeyword: false,
        keywordStyle: {height: '292px'},
        adStore: adStore,
        suggestCategoriesLoading: false,
        suggestProductLoading: false,
        textareaStyles: {
          height: '298px',
          fontSize: '12px',
          resize:"none"
        },
        alert: { // 错误提示
          success: [],
          error: [],
        }
      }
    },
    watch: {
      inputText(val) {
        this.errorKeyword = !/^[^!#%<>@*$]*$/.test(val);
      },
      adProduct$: {
        handler(adProduct$) {
          if (isMeaningful(adProduct$)) {
            this.suggestCategoriesLoading = true;
            this.suggestProductLoading = true;
            adProduct$
              .then((data) => {
                return Promise.resolve((data.records || []).map(e => e.asin));
              })
              .then((asinList) => {
                this.getSuggestCategories(asinList);
                this.getSuggestProduct(asinList);
              });
          }
        },
        immediate: true
      }
    },
    methods: {
      getSuggestCategories(asinList) {
        this.suggestCategoriesLoading = true;
        getAdProductTargetCategories({
          marketId: this.marketId,
          asinList,
        })
          .then((data) => {
            this.recommendCategoryData = (data || []).map(item => ({
              ...item,
              categoryId: item.id
            }));
            this.refreshBtnDisable();
          })
          .complete(() => this.suggestCategoriesLoading = false);
      },
      getSuggestProduct(asinList) {
        this.suggestProductLoading = true;
        getSdAdProductTargetProduct({
          marketId: this.marketId,
          asinList,
        })
          .then(({recommendedProducts}) => {
            this.recommendAsinData = recommendedProducts.map(e => ({
              ...e,
              asin: e.recommendedTargetAsin
            }));
            this.refreshBtnDisable();
          })
          .complete(() => this.suggestProductLoading = false);
      },
      addAllRecommendAsin() {
        this.addAllItem(this.recommendAsinData, 'asin', 'asin');
      },
      addRecommendAsin(index, row) {
        this.addAllItem([row], 'asin', 'asin');
      },
      addAllCategory() {
        this.addAllItem(this.recommendCategoryData, 'path', 'path');
      },
      addCategory(index, row) {
        this.addAllItem([row], 'path', 'path');
      },
      refineCategory(index, row) {
        const modal = this.$gjCreate(AppProductTargetRefineModal, {
          mountTo: adStore.SD.rootMountEl,
          props: {
            brandOption$: getAdProductTargetBrand({
              marketId: this.marketId,
              categoryId: row.id
            }),
            category: row.name,
            item: row,
            currencySymbol: adStore.SD.currencySymbol
          },
          on: {
            refine: () => {
              const item = {...row};
              Object.assign(item, modal.form);
              this.addAllItem([item], 'refine', 'path');
            }
          }
        });
      },
      refreshBtnDisable() {
        this._refreshBtnDisable(this.recommendCategoryData, 'path', 'path');
        this._refreshBtnDisable(this.recommendAsinData, 'asin', 'asin');
      },
      _refreshBtnDisable(items, type, key) {
        items.forEach(e1 => {
          if (this.form.items.some(e2 => `${type}_${e1[key]}` === e2.identity)) {
            this.$set(e1, 'btnDisabled', true);
          } else {
            this.$set(e1, 'btnDisabled', false);
          }
        });
      },
      addAllItem(items, type, key) {
        this.form.items = unique([].concat(this.form.items).concat(
          items.map(e => ({
            identity: `${type}_${e[key]}`,
            ...e,
            bid: this.form.bid,
            type,
          }))
        ), 'identity');
        this.refreshBtnDisable();
      },
      deleteAllItem() {
        this.form.items = [];
        this.refreshBtnDisable();
      },
      deleteItem(index) {
        this.form.items.splice(index, 1);
        this.refreshBtnDisable();
      },
      addByInput() {
        this.loadingInput = true;
        this.alert.success = [];
        this.alert.error = [];
        const asinList = this.inputText.split('\n').map(item => item.replace(/^(\s|\n)+|(\s|\n)+?$/, '')); // 所有
        const items = this.form.items.map(e => e.asin);
        // 校验
        asinList.forEach(element => {
          let str = element.toUpperCase()
          let rule = /^[B|b]0[A-Za-z0-9]{8}$/.test(str);
          if (rule && !this.alert.success.includes(str) && !items.includes(str)) {
            this.alert.success.push(str);
          }else {
            this.alert.error.push(element);
          }
        });
        // 设置提示
        this.textareaStyles.height = '200px';
        this.$refs.gjAlert.$refs.alert.visible = true;
        this.addAllItem(this.alert.success.map(e => ({asin: e})),'asin', 'asin');
        this.inputText = null;
        this.loadingInput = false;
      },
      // 关闭错误
      closeError() {
        setTimeout(() => {
          this.textareaStyles.height = '298px';
        }, 300);
      },
      starTo(marks) {
        if (isMeaningful(marks)) {
          return marks[0] + '-' + marks[1];
        } else {
          return '0-5';
        }
      },
      primeTo(prime) {
        if (prime === 'true') {
          return '具备Prime资格';
        } else {
          return '不具备Prime资格';
        }
      },
      formValidate() {
        let formValid = this.form.items.length > 0;
        if (!formValid) {
          this.$gjMessage.error('请添加商品投放');
          return false;
        }
        this.$refs.form.validate((valid) => {
          formValid = formValid && valid;
        });
        return formValid;
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "picker";
  /deep/.gj-table--default td:not(.vxe-footer--column) {
    &.vxe-body--column {
        height: 58px !important;
      }
  }
  .gj-picker {
    height: 445px !important;
    overflow: hidden;
  }
  
  .gj-picker__editor,
  .gj-picker__table {
    width: 50% !important;
    padding: 0;
    height: 443px !important;
  }
  
  .default-bid {
    margin-bottom: 0;
    position: absolute;
    top: 0;
    left: 280px;
  }
  
  /deep/ .el-tabs__header {
    margin-bottom: 0 !important;
  }
  
  /deep/ .gj-picker__editor--search-input .el-input__inner {
    height: 46px;
    line-height: 46px;
    font-size: 14px;
  }
  
  /deep/ .gj-table td {
    padding: 5px 0 !important;
  }
</style>


